// Minimal company directory for the readiness target-company toggle. The full
// prototype carried per-company question banks; the dashboard only needs the
// id → display name mapping plus the selection cap.

export type CompanyId =
  | 'google'
  | 'meta'
  | 'apple'
  | 'amazon'
  | 'netflix'
  | 'openai'
  | 'anthropic'

export const MAX_COMPANIES = 3

export const COMPANIES: Record<CompanyId, { id: CompanyId; name: string }> = {
  google: { id: 'google', name: 'Google' },
  meta: { id: 'meta', name: 'Meta' },
  apple: { id: 'apple', name: 'Apple' },
  amazon: { id: 'amazon', name: 'Amazon' },
  netflix: { id: 'netflix', name: 'Netflix' },
  openai: { id: 'openai', name: 'OpenAI' },
  anthropic: { id: 'anthropic', name: 'Anthropic' },
}

export const COMPANY_IDS: CompanyId[] = [
  'google',
  'meta',
  'apple',
  'amazon',
  'netflix',
  'openai',
  'anthropic',
]
